import styled from "styled-components";
import { CaptionSemibold } from "../../Typography";

import theme from "../../../styles/theme";

export default styled(CaptionSemibold)`
  color: ${() => theme.colors.green4};
  text-transform: uppercase;
  display: flex;
  margin-top: 0;
  width: 100%;
  margin-top: 16px;
  padding-bottom: 8px;
  margin-bottom: 24px;
  ${() => theme.media.desktopUp`
    margin-top: 0;
    border-bottom: ${() => theme.colors.green5} solid 1px;
  `};
`;
